import { PermissionEnum } from './types';

const permissionsTree = [
  {
    key: PermissionEnum.SECTION_DASHBOARD,
  },
  {
    key: PermissionEnum.SECTION_ACCOUNTS,
    pages: [
      {
        key: PermissionEnum.ACCOUNTS_LIST,
        actions: [
          { key: PermissionEnum.ACCOUNTS_CREATE_ACTION },
          { key: PermissionEnum.ACCOUNTS_CLOSE_ALL_ACTION },
          { key: PermissionEnum.ACCOUNTS_CLOSE_CUSTOMERS_ACTION },
        ],
      },
      {
        key: PermissionEnum.ACCOUNTS_STATEMENTS,
        actions: [{ key: PermissionEnum.ACCOUNTS_STATEMENTS_EXPORT_ACTION }],
      },
      {
        key: PermissionEnum.ACCOUNTS_CHART,
        actions: [
          { key: PermissionEnum.ACCOUNTS_CHART_ADD_CATEGORY_ACTION },
          { key: PermissionEnum.ACCOUNTS_CHART_EDIT_CATEGORY_ACTION },
          { key: PermissionEnum.ACCOUNTS_CHART_ADD_GROUP_ACTION },
          { key: PermissionEnum.ACCOUNTS_CHART_EDIT_GROUP_ACTION },
          { key: PermissionEnum.ACCOUNTS_CHART_ADD_PRIMARY_ACTION },
          { key: PermissionEnum.ACCOUNTS_CHART_EDIT_PRIMARY_ACTION },
        ],
      },
      {
        key: PermissionEnum.PSP_INTEGRATION_ACCOUNT_LIST,
        actions: [
          {
            key: PermissionEnum.PSP_INTEGRATION_ACCOUNT_ADD_ACTION,
          },
          {
            key: PermissionEnum.PSP_INTEGRATION_ACCOUNT_EDIT_ACTION,
          },
        ],
      },
      {
        key: PermissionEnum.EXTERNAL_ORGANIZATIONS_LIST,
        actions: [
          {
            key: PermissionEnum.EXTERNAL_ORGANIZATIONS_CREATE_ACTION,
          },
          {
            key: PermissionEnum.EXTERNAL_ORGANIZATIONS_UPDATE_ACTION,
          },
          {
            key: PermissionEnum.EXTERNAL_ORGANIZATIONS_DELETE_ACTION,
          },
        ],
      },
    ],
  },
  {
    key: PermissionEnum.SECTION_CUSTOMERS,
    pages: [
      {
        key: PermissionEnum.INDIVIDUAL_CUSTOMERS_LIST,
        actions: [
          { key: PermissionEnum.INDIVIDUAL_CUSTOMERS_CREATE_ACTION },
          { key: PermissionEnum.INDIVIDUAL_CUSTOMERS_EDIT_DETAILS_ACTION },
          { key: PermissionEnum.INDIVIDUAL_CUSTOMERS_EDIT_RISK_ACTION },
          { key: PermissionEnum.INDIVIDUAL_CUSTOMERS_EDIT_TARIFF_ACTION },
          { key: PermissionEnum.INDIVIDUAL_CUSTOMERS_EDIT_TOPUP_ACTION },
          { key: PermissionEnum.INDIVIDUAL_CUSTOMERS_CLOSE_ACTION },
          { key: PermissionEnum.INDIVIDUAL_CUSTOMERS_OPEN_ACTION },
          { key: PermissionEnum.INDIVIDUAL_CUSTOMERS_TERMINATE_ACTION },
          { key: PermissionEnum.INDIVIDUAL_CUSTOMERS_ANONYMISE_ACTION },
          { key: PermissionEnum.INDIVIDUAL_CUSTOMERS_UPDATE_STATUS_ACTION },
          { key: PermissionEnum.COFF_CUSTOMERS_CONVERT_TO_INDIVIDUAL_ACTION },
        ],
      },
      {
        key: PermissionEnum.INDIVIDUAL_CUSTOMERS_AML_LIST,
        actions: [
          {
            key: PermissionEnum.INDIVIDUAL_CUSTOMERS_AML_EXPORT_ACTION,
          },
          {
            key: PermissionEnum.INDIVIDUAL_CUSTOMERS_AML_APPROVE_ACTION,
          },
          {
            key: PermissionEnum.INDIVIDUAL_CUSTOMERS_AML_REJECT_ACTION,
          },
        ],
      },
      {
        key: PermissionEnum.INDIVIDUAL_CUSTOMERS_SCORE_LIST,
        actions: [
          {
            key: PermissionEnum.INDIVIDUAL_CUSTOMERS_SCORE_CREATE_ACTION,
          },
          {
            key: PermissionEnum.INDIVIDUAL_CUSTOMERS_SCORE_AUTO_ON_ACTION,
          },
          {
            key: PermissionEnum.INDIVIDUAL_CUSTOMERS_ASSIGN_SCORE_ACTION,
          },
        ],
      },
      {
        key: PermissionEnum.INDIVIDUAL_CUSTOMERS_TRANSACTIONS_WITH_WARNINGS_LIST,
      },
      {
        key: PermissionEnum.INDIVIDUAL_CUSTOMERS_DOCUMENTS_LIST,
        actions: [
          {
            key: PermissionEnum.INDIVIDUAL_CUSTOMERS_DOCUMENTS_CREATE_ACTION,
          },
          {
            key: PermissionEnum.INDIVIDUAL_CUSTOMERS_DOCUMENTS_UPDATE_STATUS_ACTION,
          },
          {
            key: PermissionEnum.INDIVIDUAL_CUSTOMERS_DOCUMENTS_DELETE_ACTION,
          },
          {
            key: PermissionEnum.INDIVIDUAL_CUSTOMERS_DOCUMENTS_EDIT_ACTION,
          },
        ],
      },
      {
        key: PermissionEnum.INDIVIDUAL_CUSTOMERS_COMMENTS_LIST,
        actions: [
          {
            key: PermissionEnum.INDIVIDUAL_CUSTOMERS_COMMENTS_CREATE_ACTION,
          },
          {
            key: PermissionEnum.INDIVIDUAL_CUSTOMERS_COMMENTS_EDIT_ACTION,
          },
          {
            key: PermissionEnum.INDIVIDUAL_CUSTOMERS_COMMENTS_DELETE_ACTION,
          },
        ],
      },
      {
        key: PermissionEnum.CUSTOMERS_DEVICES_LIST,
        actions: [
          {
            key: PermissionEnum.CUSTOMERS_SESSIONS_DELETE_ACTION,
          },
        ],
      },
      {
        key: PermissionEnum.CUSTOMERS_DEVICE_SESSIONS_LIST,
      },
      {
        key: PermissionEnum.CORPORATE_CUSTOMERS_LIST,
        actions: [
          { key: PermissionEnum.CORPORATE_CUSTOMERS_CREATE_ACTION },
          { key: PermissionEnum.CORPORATE_CUSTOMERS_EDIT_DETAILS_ACTION },
          { key: PermissionEnum.CORPORATE_CUSTOMERS_EDIT_RISK_ACTION },
          { key: PermissionEnum.CORPORATE_CUSTOMERS_EDIT_ROLES_ACTION },
          { key: PermissionEnum.CORPORATE_CUSTOMERS_EDIT_OFFICIALS_ACTION },
          {
            key: PermissionEnum.CORPORATE_CUSTOMERS_EDIT_SIGNATURE_RULES_ACTION,
          },
          { key: PermissionEnum.CORPORATE_CUSTOMERS_EDIT_TARIFF_ACTION },
          { key: PermissionEnum.CORPORATE_CUSTOMERS_EDIT_TOPUP_ACTION },
          { key: PermissionEnum.CORPORATE_CUSTOMERS_OPEN_ACTION },
          { key: PermissionEnum.CORPORATE_CUSTOMERS_CLOSE_ACTION },
          { key: PermissionEnum.CORPORATE_CUSTOMERS_TERMINATE_ACTION },
          { key: PermissionEnum.CORPORATE_CUSTOMERS_ANONYMISE_ACTION },
          { key: PermissionEnum.CORPORATE_CUSTOMERS_UPDATE_STATUS_ACTION },
        ],
      },
      {
        key: PermissionEnum.CORPORATE_CUSTOMERS_AML_LIST,
        actions: [
          {
            key: PermissionEnum.CORPORATE_CUSTOMERS_AML_EXPORT_ACTION,
          },
          {
            key: PermissionEnum.CORPORATE_CUSTOMERS_AML_APPROVE_ACTION,
          },
          {
            key: PermissionEnum.CORPORATE_CUSTOMERS_AML_REJECT_ACTION,
          },
        ],
      },
      {
        key: PermissionEnum.CORPORATE_CUSTOMERS_SCORE_LIST,
        actions: [
          {
            key: PermissionEnum.CORPORATE_CUSTOMERS_SCORE_CREATE_ACTION,
          },
          {
            key: PermissionEnum.CORPORATE_CUSTOMERS_SCORE_AUTO_ON_ACTION,
          },
          {
            key: PermissionEnum.CORPORATE_CUSTOMERS_ASSIGN_SCORE_ACTION,
          },
        ],
      },
      {
        key: PermissionEnum.CORPORATE_CUSTOMERS_TRANSACTIONS_WITH_WARNINGS_LIST,
      },
      {
        key: PermissionEnum.CORPORATE_CUSTOMERS_DOCUMENTS_LIST,
        actions: [
          {
            key: PermissionEnum.CORPORATE_CUSTOMERS_DOCUMENTS_CREATE_ACTION,
          },
          {
            key: PermissionEnum.CORPORATE_CUSTOMERS_DOCUMENTS_UPDATE_STATUS_ACTION,
          },
          { key: PermissionEnum.CORPORATE_CUSTOMERS_DOCUMENTS_DELETE_ACTION },
          { key: PermissionEnum.CORPORATE_CUSTOMERS_DOCUMENTS_EDIT_ACTION },
        ],
      },
      {
        key: PermissionEnum.CORPORATE_CUSTOMERS_COMMENTS_LIST,
        actions: [
          {
            key: PermissionEnum.CORPORATE_CUSTOMERS_COMMENTS_CREATE_ACTION,
          },
          {
            key: PermissionEnum.CORPORATE_CUSTOMERS_COMMENTS_EDIT_ACTION,
          },
          { key: PermissionEnum.CORPORATE_CUSTOMERS_COMMENTS_DELETE_ACTION },
        ],
      },
      {
        key: PermissionEnum.CUSTOMERS_STATEMENTS_LIST,
      },
      {
        key: PermissionEnum.CUSTOMERS_EXTERNAL_ORGANIZATIONS_LIST,
      },
      {
        key: PermissionEnum.MESSAGES_LIST,
        actions: [
          { key: PermissionEnum.MESSAGES_ASSIGN_CHAT_TO_ME_ACTION },
          { key: PermissionEnum.MESSAGES_ASSIGN_CHAT_TO_ANOTHER_ACTION },
        ],
      },
      {
        key: PermissionEnum.APPLICATIONS_CUSTOMERS_LIST,
        actions: [
          { key: PermissionEnum.APPLICATIONS_CUSTOMERS_ACCEPT_ACTION },
          { key: PermissionEnum.APPLICATIONS_CUSTOMERS_CREATE_ACTION },
          { key: PermissionEnum.APPLICATIONS_CUSTOMERS_EDIT_ACTION },
          { key: PermissionEnum.APPLICATIONS_CUSTOMERS_SUBMIT_ACTION },
        ],
      },
      {
        key: PermissionEnum.APPLICATIONS_CUSTOMERS_AML_LIST,
        actions: [
          {
            key: PermissionEnum.APPLICATIONS_CUSTOMERS_AML_APPROVE_ACTION,
          },
          {
            key: PermissionEnum.APPLICATIONS_CUSTOMERS_AML_REJECT_ACTION,
          },
        ],
      },
      {
        key: PermissionEnum.APPLICATIONS_CUSTOMERS_SCORE_LIST,
        actions: [
          {
            key: PermissionEnum.APPLICATIONS_CUSTOMERS_SCORE_CREATE_ACTION,
          },
          {
            key: PermissionEnum.APPLICATIONS_CUSTOMERS_SCORE_AUTO_ON_ACTION,
          },
          {
            key: PermissionEnum.APPLICATIONS_CUSTOMERS_ASSIGN_SCORE_ACTION,
          },
        ],
      },
      {
        key: PermissionEnum.APPLICATIONS_CUSTOMERS_DOCUMENTS_LIST,
        actions: [
          {
            key: PermissionEnum.APPLICATIONS_CUSTOMERS_DOCUMENTS_CREATE_ACTION,
          },
          {
            key: PermissionEnum.APPLICATIONS_CUSTOMERS_DOCUMENTS_UPDATE_STATUS_ACTION,
          },
          {
            key: PermissionEnum.APPLICATIONS_CUSTOMERS_DOCUMENTS_DELETE_ACTION,
          },
          { key: PermissionEnum.APPLICATIONS_CUSTOMERS_DOCUMENTS_EDIT_ACTION },
        ],
      },
      {
        key: PermissionEnum.CHANNELS_LIST,
        actions: [
          {
            key: PermissionEnum.CHANNELS_CREATE_ACTION,
          },
          {
            key: PermissionEnum.CHANNELS_UPDATE_ACTION,
          },
        ],
      },
      {
        key: PermissionEnum.NOTIFICATIONS_MESSAGING_AND_CUSTOMERS_LIST,
        actions: [
          {
            key: PermissionEnum.NOTIFICATIONS_MESSAGING_AND_CUSTOMERS_EDIT_ACTION,
          },
        ],
      },
      {
        key: PermissionEnum.NOTIFICATIONS_MESSAGING_AND_CUSTOMERS_COMMENTS_LIST,
        actions: [
          {
            key: PermissionEnum.NOTIFICATIONS_MESSAGING_AND_CUSTOMERS_COMMENTS_CREATE_ACTION,
          },
          {
            key: PermissionEnum.NOTIFICATIONS_MESSAGING_AND_CUSTOMERS_COMMENTS_EDIT_ACTION,
          },
        ],
      },
    ],
  },
  {
    key: PermissionEnum.SECTION_BENEFICIARIES,
    pages: [
      {
        key: PermissionEnum.BENEFICIARIES_LIST,
        actions: [
          {
            key: PermissionEnum.BENEFICIARIES_CREATE_ACTION,
          },
          {
            key: PermissionEnum.BENEFICIARIES_UPDATE_ACTION,
          },
          {
            key: PermissionEnum.BENEFICIARIES_EDIT_STATUS_ACTION,
          },
          {
            key: PermissionEnum.BENEFICIARIES_DELETE_ACTION,
          },
        ],
      },
    ],
  },
  {
    key: PermissionEnum.SECTION_AML_KYC,
    pages: [
      {
        key: PermissionEnum.BLACKLISTS_LIST,
        actions: [
          { key: PermissionEnum.BLACKLISTS_ADD_ACTION },
          { key: PermissionEnum.BLACKLISTS_EDIT_ACTION },
          { key: PermissionEnum.BLACKLISTS_DELETE_ACTION },
        ],
      },
      {
        key: PermissionEnum.BLACKLISTS_ITEMS_LIST,
        actions: [
          { key: PermissionEnum.BLACKLISTS_ITEMS_CREATE_ACTION },
          { key: PermissionEnum.BLACKLISTS_ITEMS_DELETE_ACTION },
        ],
      },
      {
        key: PermissionEnum.AML_SETTINGS_LIST,
        actions: [
          { key: PermissionEnum.AML_SETTINGS_CATEGORY_ADD_ACTION },
          { key: PermissionEnum.AML_SETTINGS_CATEGORY_EDIT_ACTION },
          { key: PermissionEnum.AML_SETTINGS_CATEGORY_DELETE_ACTION },
        ],
      },
      {
        key: PermissionEnum.AML_GEO_LIST,
        actions: [
          { key: PermissionEnum.AML_GEO_EDIT_SETTINGS_ACTION },
          { key: PermissionEnum.AML_GEO_EDIT_RS_ACTION },
        ],
      },
      {
        key: PermissionEnum.SETTINGS_TRANSACTIONS_VOLUMES_LIST,
        actions: [
          { key: PermissionEnum.SETTINGS_TRANSACTIONS_VOLUMES_CREATE_ACTION },
          { key: PermissionEnum.SETTINGS_TRANSACTIONS_VOLUMES_EDIT_ACTION },
          { key: PermissionEnum.SETTINGS_TRANSACTIONS_VOLUMES_DELETE_ACTION },
        ],
      },
      {
        key: PermissionEnum.SETTINGS_PRODUCTS_LIST,
        actions: [
          { key: PermissionEnum.SETTINGS_PRODUCTS_CREATE_ACTION },
          { key: PermissionEnum.SETTINGS_PRODUCTS_EDIT_ACTION },
          { key: PermissionEnum.SETTINGS_PRODUCTS_DELETE_ACTION },
        ],
      },
      {
        key: PermissionEnum.SETTINGS_DELIVERY_CHANNELS_LIST,
        actions: [
          { key: PermissionEnum.SETTINGS_DELIVERY_CHANNELS_CREATE_ACTION },
          { key: PermissionEnum.SETTINGS_DELIVERY_CHANNELS_EDIT_ACTION },
          { key: PermissionEnum.SETTINGS_DELIVERY_CHANNELS_DELETE_ACTION },
        ],
      },
      {
        key: PermissionEnum.SETTINGS_CLIENT_ACTIVITIES_LIST,
        actions: [
          { key: PermissionEnum.SETTINGS_CLIENT_ACTIVITIES_CREATE_ACTION },
          { key: PermissionEnum.SETTINGS_CLIENT_ACTIVITIES_EDIT_ACTION },
          { key: PermissionEnum.SETTINGS_CLIENT_ACTIVITIES_DELETE_ACTION },
        ],
      },
      {
        key: PermissionEnum.SETTINGS_SOURCES_OF_FUNDS_LIST,
        actions: [
          { key: PermissionEnum.SETTINGS_SOURCES_OF_FUNDS_CREATE_ACTION },
          { key: PermissionEnum.SETTINGS_SOURCES_OF_FUNDS_EDIT_ACTION },
          { key: PermissionEnum.SETTINGS_SOURCES_OF_FUNDS_DELETE_ACTION },
        ],
      },
      {
        key: PermissionEnum.SETTINGS_INCORPORATION_DATES_LIST,
        actions: [
          { key: PermissionEnum.SETTINGS_INCORPORATION_DATES_CREATE_ACTION },
          { key: PermissionEnum.SETTINGS_INCORPORATION_DATES_EDIT_ACTION },
          { key: PermissionEnum.SETTINGS_INCORPORATION_DATES_DELETE_ACTION },
        ],
      },
      {
        key: PermissionEnum.SETTINGS_SIC_CODES_LIST,
      },
      {
        key: PermissionEnum.AML_MONITORING_RULES_LIST,
        actions: [
          { key: PermissionEnum.AML_MONITORING_RULES_ADD_ACTION },
          { key: PermissionEnum.AML_MONITORING_RULES_EDIT_ACTION },
          { key: PermissionEnum.AML_MONITORING_RULES_DELETE_ACTION },
        ],
      },
      {
        key: PermissionEnum.SETTINGS_TRANSACTIONS_TYPES_RISK_SCORE_LIST,
        actions: [
          {
            key: PermissionEnum.SETTINGS_TRANSACTIONS_TYPES_RISK_SCORE_CREATE_ACTION,
          },
          {
            key: PermissionEnum.SETTINGS_TRANSACTIONS_TYPES_RISK_SCORE_UPDATE_ACTION,
          },
        ],
      },
      {
        key: PermissionEnum.SETTINGS_RISK_SCORE_RANGES_LIST,
        actions: [
          { key: PermissionEnum.SETTINGS_RISK_SCORE_RANGES_CREATE_ACTION },
          { key: PermissionEnum.SETTINGS_RISK_SCORE_RANGES_EDIT_ACTION },
          { key: PermissionEnum.SETTINGS_RISK_SCORE_RANGES_DELETE_ACTION },
        ],
      },
    ],
  },
  {
    key: PermissionEnum.SECTION_TRANSACTIONS,
    pages: [
      {
        key: PermissionEnum.TRANSACTIONS_IMPORT_LIST,
      },
      {
        key: PermissionEnum.TRANSACTIONS_EXPORT_LIST,
        actions: [{ key: PermissionEnum.TRANSACTIONS_EXPORT_CREATE_ACTION }],
      },
      {
        key: PermissionEnum.TRANSACTIONS_INCOMING_LIST,
        actions: [
          { key: PermissionEnum.TRANSACTIONS_INCOMING_CREATE_ACTION },
          { key: PermissionEnum.TRANSACTIONS_INCOMING_EDIT_ACTION },
          { key: PermissionEnum.TRANSACTIONS_INCOMING_REVERSE_ACTION },
          { key: PermissionEnum.TRANSACTIONS_INCOMING_CANCEL_ACTION },
          { key: PermissionEnum.TRANSACTIONS_INCOMING_REVIEW_ACTION },
          { key: PermissionEnum.TRANSACTIONS_INCOMING_REQUEST_INFO_ACTION },
          { key: PermissionEnum.TRANSACTIONS_INCOMING_SEND_TO_AML_ACTION },
          { key: PermissionEnum.TRANSACTIONS_INCOMING_ACCEPT_FILE_ACTION },
          { key: PermissionEnum.TRANSACTIONS_INCOMING_ACCEPT_API_ACTION },
        ],
      },
      {
        key: PermissionEnum.TRANSACTIONS_INCOMING_COMMENTS_LIST,
        actions: [
          { key: PermissionEnum.TRANSACTIONS_INCOMING_COMMENTS_CREATE_ACTION },
          { key: PermissionEnum.TRANSACTIONS_INCOMING_COMMENTS_EDIT_ACTION },
          { key: PermissionEnum.TRANSACTIONS_INCOMING_COMMENTS_DELETE_ACTION },
        ],
      },
      { key: PermissionEnum.TRANSACTION_QUEUE_ITEMS_INCOMING_LIST },
      {
        key: PermissionEnum.TRANSACTIONS_INCOMING_AML_DOCUMENTS_LIST,
        actions: [
          {
            key: PermissionEnum.TRANSACTIONS_INCOMING_AML_DOCUMENT_CREATE_ACTION,
          },
          {
            key: PermissionEnum.TRANSACTIONS_INCOMING_AML_DOCUMENT_DELETE_ACTION,
          },
        ],
      },
      {
        key: PermissionEnum.TRANSACTIONS_OUTGOING_LIST,
        actions: [
          { key: PermissionEnum.TRANSACTIONS_OUTGOING_CREATE_ACTION },
          {
            key: PermissionEnum.TRANSACTIONS_OUTGOING_PROCESS_CREATED_BY_EMPLOYEE_ACTION,
          },
          {
            key: PermissionEnum.TRANSACTIONS_OUTGOING_PROCESS_CREATED_BY_CUSTOMER_ACTION,
          },
          { key: PermissionEnum.TRANSACTIONS_OUTGOING_CHOOSE_PSP_ACTION },
          { key: PermissionEnum.TRANSACTIONS_OUTGOING_EDIT_ACTION },
          { key: PermissionEnum.TRANSACTIONS_OUTGOING_REVERSE_ACTION },
          { key: PermissionEnum.TRANSACTIONS_OUTGOING_CANCEL_ACTION },
          { key: PermissionEnum.TRANSACTIONS_OUTGOING_REVIEW_ACTION },
          { key: PermissionEnum.TRANSACTIONS_OUTGOING_REQUEST_INFO_ACTION },
          { key: PermissionEnum.TRANSACTIONS_OUTGOING_SEND_TO_AML_ACTION },
          { key: PermissionEnum.TRANSACTIONS_OUTGOING_ACCEPT_FILE_ACTION },
          { key: PermissionEnum.TRANSACTIONS_OUTGOING_ACCEPT_API_ACTION },
        ],
      },
      {
        key: PermissionEnum.TRANSACTIONS_OUTGOING_COMMENTS_LIST,
        actions: [
          {
            key: PermissionEnum.TRANSACTIONS_OUTGOING_COMMENTS_CREATE_ACTION,
          },
          { key: PermissionEnum.TRANSACTIONS_OUTGOING_COMMENTS_EDIT_ACTION },
          {
            key: PermissionEnum.TRANSACTIONS_OUTGOING_COMMENTS_DELETE_ACTION,
          },
        ],
      },
      { key: PermissionEnum.TRANSACTION_QUEUE_ITEMS_OUTGOING_LIST },
      {
        key: PermissionEnum.TRANSACTIONS_OUTGOING_AML_DOCUMENTS_LIST,
        actions: [
          {
            key: PermissionEnum.TRANSACTIONS_OUTGOING_AML_DOCUMENT_CREATE_ACTION,
          },
          {
            key: PermissionEnum.TRANSACTIONS_OUTGOING_AML_DOCUMENT_DELETE_ACTION,
          },
        ],
      },
      {
        key: PermissionEnum.TRANSACTIONS_INTERNAL_LIST,
        actions: [
          { key: PermissionEnum.TRANSACTIONS_INTERNAL_CREATE_ACTION },
          { key: PermissionEnum.TRANSACTIONS_INTERNAL_EDIT_ACTION },
        ],
      },
      {
        key: PermissionEnum.TRANSACTIONS_INTERNAL_COMMENTS_LIST,
        actions: [
          { key: PermissionEnum.TRANSACTIONS_INTERNAL_COMMENTS_CREATE_ACTION },
          { key: PermissionEnum.TRANSACTIONS_INTERNAL_COMMENTS_EDIT_ACTION },
          { key: PermissionEnum.TRANSACTIONS_INTERNAL_COMMENTS_DELETE_ACTION },
        ],
      },
      { key: PermissionEnum.TRANSACTION_QUEUE_ITEMS_INTERNAL_LIST },
      {
        key: PermissionEnum.TRANSACTIONS_INTERNAL_AML_DOCUMENTS_LIST,
        actions: [
          {
            key: PermissionEnum.TRANSACTIONS_INTERNAL_AML_DOCUMENT_CREATE_ACTION,
          },
          {
            key: PermissionEnum.TRANSACTIONS_INTERNAL_AML_DOCUMENT_DELETE_ACTION,
          },
        ],
      },
      {
        key: PermissionEnum.TRANSACTIONS_EXCHANGE_LIST,
        actions: [
          { key: PermissionEnum.TRANSACTIONS_EXCHANGE_CREATE_ACTION },
          {
            key: PermissionEnum.TRANSACTIONS_EXCHANGE_PROCESS_CREATED_BY_EMPLOYEE_ACTION,
          },
          {
            key: PermissionEnum.TRANSACTIONS_EXCHANGE_PROCESS_CREATED_BY_CUSTOMER_ACTION,
          },
          { key: PermissionEnum.TRANSACTIONS_EXCHANGE_CHOOSE_PSP_ACTION },
          { key: PermissionEnum.TRANSACTIONS_EXCHANGE_EDIT_ACTION },
          { key: PermissionEnum.TRANSACTIONS_EXCHANGE_REVERSE_ACTION },
          { key: PermissionEnum.TRANSACTIONS_EXCHANGE_CANCEL_ACTION },
          { key: PermissionEnum.TRANSACTIONS_EXCHANGE_REVIEW_ACTION },
          { key: PermissionEnum.TRANSACTIONS_EXCHANGE_REQUEST_INFO_ACTION },
          { key: PermissionEnum.TRANSACTIONS_EXCHANGE_SEND_TO_AML_ACTION },
          { key: PermissionEnum.TRANSACTIONS_EXCHANGE_AML_APPROVE_ACTION },
          { key: PermissionEnum.TRANSACTIONS_EXCHANGE_AML_REJECT_ACTION },
          { key: PermissionEnum.TRANSACTIONS_EXCHANGE_ACCEPT_FILE_ACTION },
          { key: PermissionEnum.TRANSACTIONS_EXCHANGE_ACCEPT_API_ACTION },
        ],
      },
      {
        key: PermissionEnum.TRANSACTIONS_EXCHANGE_COMMENTS_LIST,
        actions: [
          { key: PermissionEnum.TRANSACTIONS_EXCHANGE_COMMENTS_CREATE_ACTION },
          {
            key: PermissionEnum.TRANSACTIONS_EXCHANGE_COMMENTS_EDIT_ACTION,
          },
          {
            key: PermissionEnum.TRANSACTIONS_EXCHANGE_COMMENTS_DELETE_ACTION,
          },
        ],
      },
      { key: PermissionEnum.TRANSACTION_QUEUE_ITEMS_EXCHANGE_LIST },
      {
        key: PermissionEnum.TRANSACTIONS_GENERAL_LEDGER_LIST,
        actions: [
          { key: PermissionEnum.TRANSACTIONS_GENERAL_LEDGER_CREATE_ACTION },
          { key: PermissionEnum.TRANSACTIONS_GENERAL_LEDGER_EDIT_ACTION },
          { key: PermissionEnum.TRANSACTIONS_GENERAL_LEDGER_REVERSE_ACTION },
          {
            key: PermissionEnum.TRANSACTIONS_GENERAL_LEDGER_DELETE_ACTION,
          },
        ],
      },
      {
        key: PermissionEnum.TRANSACTIONS_GENERAL_LEDGER_DOCUMENTS_LIST,
        actions: [
          {
            key: PermissionEnum.TRANSACTIONS_GENERAL_LEDGER_DOCUMENTS_CREATE_ACTION,
          },
          {
            key: PermissionEnum.TRANSACTIONS_GENERAL_LEDGER_DOCUMENTS_EDIT_ACTION,
          },
          {
            key: PermissionEnum.TRANSACTIONS_GENERAL_LEDGER_DOCUMENTS_DELETE_ACTION,
          },
        ],
      },
      {
        key: PermissionEnum.TRANSACTIONS_NOSTRO_LIST,
        actions: [
          { key: PermissionEnum.TRANSACTIONS_NOSTRO_CREATE_ACTION },
          { key: PermissionEnum.TRANSACTIONS_NOSTRO_EDIT_ACTION },
          { key: PermissionEnum.TRANSACTIONS_NOSTRO_REVERSE_ACTION },
        ],
      },
      {
        key: PermissionEnum.TRANSACTIONS_NOSTRO_COMMENTS_LIST,
        actions: [
          { key: PermissionEnum.TRANSACTIONS_NOSTRO_COMMENTS_CREATE_ACTION },
          { key: PermissionEnum.TRANSACTIONS_NOSTRO_COMMENTS_EDIT_ACTION },
          { key: PermissionEnum.TRANSACTIONS_NOSTRO_COMMENTS_DELETE_ACTION },
        ],
      },
      { key: PermissionEnum.TRANSACTION_QUEUE_ITEMS_NOSTRO_LIST },
      {
        key: PermissionEnum.PAYMENTS_ORDERS_LIST,
        actions: [
          { key: PermissionEnum.PAYMENTS_ORDERS_CREATE_ACTION },
          { key: PermissionEnum.PAYMENTS_ORDERS_EDIT_ACTION },
          { key: PermissionEnum.PAYMENTS_ORDERS_DELETE_ACTION },
        ],
      },
      {
        key: PermissionEnum.PAYMENTS_ORDERS_BENEFICIARIES_LIST,
        actions: [
          { key: PermissionEnum.PAYMENTS_ORDERS_BENEFICIARIES_CREATE_ACTION },
          { key: PermissionEnum.PAYMENTS_ORDERS_BENEFICIARIES_EDIT_ACTION },
          { key: PermissionEnum.PAYMENTS_ORDERS_BENEFICIARIES_DELETE_ACTION },
        ],
      },
      {
        key: PermissionEnum.TRANSACTIONS_INCOMING_AML_LIST,
        actions: [
          { key: PermissionEnum.TRANSACTIONS_INCOMING_AML_APPROVE_ACTION },
          { key: PermissionEnum.TRANSACTIONS_INCOMING_AML_REJECT_ACTION },
        ],
      },
      {
        key: PermissionEnum.TRANSACTIONS_OUTGOING_AML_LIST,
        actions: [
          { key: PermissionEnum.TRANSACTIONS_OUTGOING_AML_APPROVE_ACTION },
          { key: PermissionEnum.TRANSACTIONS_OUTGOING_AML_REJECT_ACTION },
        ],
      },
      {
        key: PermissionEnum.TRANSACTIONS_INTERNAL_AML_LIST,
        actions: [
          {
            key: PermissionEnum.TRANSACTIONS_INTERNAL_AML_APPROVE_ACTION,
          },
          {
            key: PermissionEnum.TRANSACTIONS_INTERNAL_AML_REJECT_ACTION,
          },
        ],
      },
      {
        key: PermissionEnum.TRANSACTIONS_DOCUMENTS_LIST,
        actions: [
          {
            key: PermissionEnum.TRANSACTIONS_DOCUMENTS_CREATE_ACTION,
          },
          {
            key: PermissionEnum.TRANSACTIONS_DOCUMENTS_EDIT_ACTION,
          },
          {
            key: PermissionEnum.TRANSACTIONS_DOCUMENTS_DELETE_ACTION,
          },
        ],
      },
      {
        key: PermissionEnum.NOTIFICATIONS_TRANSACTIONS_LIST,
        actions: [
          { key: PermissionEnum.NOTIFICATIONS_TRANSACTIONS_EDIT_ACTION },
        ],
      },
      {
        key: PermissionEnum.NOTIFICATIONS_TRANSACTIONS_COMMENTS_LIST,
        actions: [
          {
            key: PermissionEnum.NOTIFICATIONS_TRANSACTIONS_COMMENTS_CREATE_ACTION,
          },
          {
            key: PermissionEnum.NOTIFICATIONS_TRANSACTIONS_COMMENTS_EDIT_ACTION,
          },
        ],
      },
    ],
  },
  {
    key: PermissionEnum.SECTION_CARDS,
    pages: [
      {
        key: PermissionEnum.CARDS_LIST,
        actions: [
          { key: PermissionEnum.CARDS_ACCEPT_ACTION },
          { key: PermissionEnum.CARDS_ACTIVATE_ACTION },
          { key: PermissionEnum.CARDS_FREEZE_ACTION },
          { key: PermissionEnum.CARDS_UNFREEZE_ACTION },
          { key: PermissionEnum.CARDS_CANCEL_ACTION },
        ],
      },
      {
        key: PermissionEnum.CARDS_OCT_LIST,
        actions: [
          { key: PermissionEnum.CARDS_OCT_PROCESS_ACTION },
          { key: PermissionEnum.CARDS_OCT_CHOOSE_PSP_ACTION },
          { key: PermissionEnum.CARDS_OCT_REVERSE_ACTION },
          { key: PermissionEnum.CARDS_OCT_CANCEL_ACTION },
          { key: PermissionEnum.CARDS_OCT_REVIEW_AND_APPROVE_ACTION },
          { key: PermissionEnum.CARDS_OCT_REQUEST_INFO_ACTION },
          { key: PermissionEnum.CARDS_OCT_REQUEST_SEND_TO_AML_ACTION },
          { key: PermissionEnum.CARDS_OCT_REQUEST_AML_APPROVE_ACTION },
          { key: PermissionEnum.CARDS_OCT_REQUEST_AML_REJECT_ACTION },
        ],
      },
    ],
  },
  {
    key: PermissionEnum.SECTION_REPORTS,
    pages: [
      {
        key: PermissionEnum.REPORTS_BALANCE_SHEET_LIST,
        actions: [{ key: PermissionEnum.REPORTS_BALANCE_SHEET_EXPORT_ACTION }],
      },
      {
        key: PermissionEnum.REPORTS_PROFIT_LOSS_LIST,
        actions: [{ key: PermissionEnum.REPORTS_PROFIT_LOSS_EXPORT_ACTION }],
      },
      {
        key: PermissionEnum.REPORTS_SAFEGUARDING_LIST,
        actions: [{ key: PermissionEnum.REPORTS_SAFEGUARDING_EXPORT_ACTION }],
      },
      {
        key: PermissionEnum.REPORTS_CAPITAL_ADEQUACY_LIST,
        actions: [
          { key: PermissionEnum.REPORTS_CAPITAL_ADEQUACY_EXPORT_ACTION },
        ],
      },
      {
        key: PermissionEnum.REPORTS_PSP_LIST,
        actions: [{ key: PermissionEnum.REPORTS_PSP_EXPORT_ACTION }],
      },
      {
        key: PermissionEnum.REPORTS_CURRENCY_POSITION_LIST,
        actions: [
          { key: PermissionEnum.REPORTS_CURRENCY_POSITION_EXPORT_ACTION },
        ],
      },
      {
        key: PermissionEnum.REPORTS_REVALUATION_LIST,
        actions: [
          { key: PermissionEnum.REPORTS_REVALUATION_CREATE_ACTION },
          { key: PermissionEnum.REPORTS_REVALUATION_DELETE_ACTION },
        ],
      },
      {
        key: PermissionEnum.REPORTS_ACCOUNTING_JOBS_LITS,
        actions: [
          { key: PermissionEnum.REPORTS_ACCOUNTING_JOBS_CREATE_ACTION },
          { key: PermissionEnum.REPORTS_ACCOUNTING_JOBS_EDIT_ACTION },
          {
            key: PermissionEnum.REPORTS_ACCOUNTING_JOBS_RESTATEMENT_CREATE_ACTION,
          },
          { key: PermissionEnum.REPORTS_ACCOUNTING_JOBS_CANCEL_ACTION },
        ],
      },
      {
        key: PermissionEnum.WARNINGS_LIST,
        actions: [{ key: PermissionEnum.WARNINGS_DOWNLOAD_ACTION }],
      },
      {
        key: PermissionEnum.REGULATORY_REPORT_FINTRAC_LIST,
        actions: [
          { key: PermissionEnum.REGULATORY_REPORT_FINTRAC_CREATE_ACTION },
          { key: PermissionEnum.REGULATORY_REPORT_FINTRAC_UPDATE_ACTION },
          { key: PermissionEnum.REGULATORY_REPORT_FINTRAC_DELETE_ACTION },
          {
            key: PermissionEnum.SETTINGS_REGULATORY_REPORT_FINTRAC_EDIT_ACTION,
          },
        ],
      },
      {
        key: PermissionEnum.NOTIFICATIONS_REPORTS_LIST,
        actions: [{ key: PermissionEnum.NOTIFICATIONS_REPORTS_EDIT_ACTION }],
      },
      {
        key: PermissionEnum.NOTIFICATIONS_REPORTS_COMMENTS_LIST,
        actions: [
          { key: PermissionEnum.NOTIFICATIONS_REPORTS_COMMENTS_CREATE_ACTION },
          { key: PermissionEnum.NOTIFICATIONS_REPORTS_COMMENTS_EDIT_ACTION },
        ],
      },
    ],
  },
  {
    key: PermissionEnum.SECTION_PSP,
    pages: [
      {
        key: PermissionEnum.PSP_LIST,
        actions: [
          { key: PermissionEnum.PSP_ADD_ACTION },
          { key: PermissionEnum.PSP_EDIT_ACTION },
          { key: PermissionEnum.PSP_DELETE_ACTION },
          { key: PermissionEnum.PSP_ACCOUNT_ADD_ACTION },
          { key: PermissionEnum.PSP_ACCOUNT_EDIT_ACTION },
          { key: PermissionEnum.PSP_ACCOUNT_DELETE_ACTION },
          { key: PermissionEnum.PSP_INTEGRATION_FEE_SETTINGS_EDIT_ACTION },
          {
            key: PermissionEnum.PSP_INTEGRATION_EXTERNAL_VAULT_SETTINGS_EDIT_ACTION,
          },
          {
            key: PermissionEnum.PSP_INTEGRATION_ACCOUNT_AUTO_CREATE_CURRENCIES_EDIT_ACTION,
          },
          {
            key: PermissionEnum.PSP_INTEGRATION_EXCHANGE_TOLERANCE_EDIT_ACTION,
          },
        ],
      },
      {
        key: PermissionEnum.PSP_DOCUMENTS_LIST,
        actions: [
          { key: PermissionEnum.PSP_DOCUMENTS_CREATE_ACTION },
          { key: PermissionEnum.PSP_DOCUMENTS_DELETE_ACTION },
          { key: PermissionEnum.PSP_DOCUMENTS_EDIT_ACTION },
        ],
      },
      {
        key: PermissionEnum.PSP_ACCOUNT_DOCUMENTS_LIST,
        actions: [
          { key: PermissionEnum.PSP_ACCOUNT_DOCUMENTS_CREATE_ACTION },
          { key: PermissionEnum.PSP_ACCOUNT_DOCUMENTS_DELETE_ACTION },
          { key: PermissionEnum.PSP_ACCOUNT_DOCUMENTS_EDIT_ACTION },
        ],
      },
      {
        key: PermissionEnum.PSP_INTEGRATION_LOGS_LIST,
      },
      {
        key: PermissionEnum.PSP_INTEGRATION_LOGS_LIST_BY_PSP_PARTNER,
      },
      {
        key: PermissionEnum.PSP_INTEGRATION_CASPS_CHAINS_LIST,
        actions: [
          { key: PermissionEnum.PSP_INTEGRATION_CASPS_CHAINS_CREATE_ACTION },
          { key: PermissionEnum.PSP_INTEGRATION_CASPS_CHAINS_DELETE_ACTION },
        ],
      },
      {
        key: PermissionEnum.PSP_INTEGRATION_PAYMENT_ACCOUNT_LIST,
        actions: [
          {
            key: PermissionEnum.PSP_INTEGRATION_PAYMENT_ACCOUNT_ADD_ACTION,
          },
          {
            key: PermissionEnum.PSP_INTEGRATION_PAYMENT_ACCOUNT_EDIT_ACTION,
          },
          {
            key: PermissionEnum.PSP_INTEGRATION_PAYMENT_ACCOUNT_DELETE_ACTION,
          },
        ],
      },
      {
        key: PermissionEnum.PSP_INTEGRATION_FEE_TIER_LIST,
        actions: [
          { key: PermissionEnum.PSP_INTEGRATION_FEE_TIER_ADD_ACTION },
          { key: PermissionEnum.PSP_INTEGRATION_FEE_TIER_EDIT_ACTION },
          { key: PermissionEnum.PSP_INTEGRATION_FEE_TIER_DELETE_ACTION },
        ],
      },
    ],
  },
  {
    key: PermissionEnum.SECTION_EXCHANGE_SETTINGS,
    pages: [
      {
        key: PermissionEnum.SETTINGS_EXCHANGE_RATES_LIST,
        actions: [{ key: PermissionEnum.SETTINGS_EXCHANGE_EDIT_PAIRS_ACTION }],
      },
      {
        key: PermissionEnum.SETTINGS_EXCHANGE_MARGINS_LIST,
        actions: [
          { key: PermissionEnum.SETTINGS_EXCHANGE_EDIT_MARGINS_ACTION },
        ],
      },
      {
        key: PermissionEnum.SETTINGS_AUTO_EXCHANGE_LIST,
        actions: [
          { key: PermissionEnum.SETTINGS_AUTO_EXCHANGE_CREATE_ACTION },
          { key: PermissionEnum.SETTINGS_AUTO_EXCHANGE_UPDATE_ACTION },
        ],
      },
      {
        key: PermissionEnum.SETTINGS_CUSTOM_RATE_EXCHANGE_LIST,
        actions: [
          { key: PermissionEnum.SETTINGS_CUSTOM_RATE_EXCHANGE_CREATE_ACTION },
          { key: PermissionEnum.SETTINGS_CUSTOM_RATE_EXCHANGE_UPDATE_ACTION },
        ],
      },
    ],
  },
  {
    key: PermissionEnum.SECTION_FEE_TARIFFS,
    pages: [
      {
        key: PermissionEnum.TARIFFS_LIST,
        actions: [
          { key: PermissionEnum.TARIFFS_CREATE_ACTION },
          { key: PermissionEnum.TARIFFS_EDIT_ACTION },
        ],
      },
      {
        key: PermissionEnum.FEES_TYPES_LIST,
        actions: [
          { key: PermissionEnum.FEES_TYPES_CREATE_ACTION },
          { key: PermissionEnum.FEES_TYPES_EDIT_ACTION },
        ],
      },
      {
        key: PermissionEnum.FEES_LIST,
        actions: [
          { key: PermissionEnum.FEES_CREATE_ACTION },
          { key: PermissionEnum.FEES_EDIT_ACTION },
        ],
      },
    ],
  },

  {
    key: PermissionEnum.SECTION_ADMINISTRATION,
    pages: [
      {
        key: PermissionEnum.USERS_LIST,
        actions: [
          { key: PermissionEnum.USERS_CREATE_ACTION },
          { key: PermissionEnum.USERS_EDIT_ACTION },
          { key: PermissionEnum.USERS_ARCHIVE_ACTION },
          { key: PermissionEnum.USERS_EDIT_STATUS_ACTION },
          { key: PermissionEnum.USERS_EDIT_STATUS_ACTION },
          { key: PermissionEnum.USERS_RESET_NOTIFICATIONS_TYPES_ACTION },
          { key: PermissionEnum.USERS_EDIT_NOTIFICATIONS_TYPES_ACTION },
          {
            key: PermissionEnum.USERS_EDIT_NOTIFICATIONS_TYPES_TEMPLATE_ACTION,
          },
        ],
      },
      {
        key: PermissionEnum.USERS_ROLES_LIST,
        actions: [
          { key: PermissionEnum.USERS_ROLES_CREATE_ACTION },
          { key: PermissionEnum.USERS_ROLES_EDIT_ACTION },
          { key: PermissionEnum.USERS_ROLES_ARCHIVE_ACTION },
        ],
      },
      {
        key: PermissionEnum.EMPLOYEES_DEVICES_LIST,
        actions: [{ key: PermissionEnum.EMPLOYEES_SESSIONS_DELETE_ACTION }],
      },
      {
        key: PermissionEnum.EMPLOYEES_DEVICE_SESSIONS_LIST,
      },
      {
        key: PermissionEnum.USERS_DEVICE_SESSIONS_LIST,
      },
      {
        key: PermissionEnum.SETTINGS_SYSTEM_LIST,
        actions: [
          { key: PermissionEnum.SETTINGS_SYSTEM_CREATE_ACTION },
          { key: PermissionEnum.SETTINGS_SYSTEM_EDIT_ACTION },
        ],
      },
      {
        key: PermissionEnum.SETTINGS_FACTORS_LIST,
        actions: [{ key: PermissionEnum.SETTINGS_FACTORS_ACTION }],
      },
      {
        key: PermissionEnum.SETTINGS_CURRENCIES_LIST,
        actions: [
          { key: PermissionEnum.SETTINGS_CURRENCIES_CREATE_ACTION },
          { key: PermissionEnum.SETTINGS_CURRENCIES_EDIT_ACTION },
        ],
      },
      {
        key: PermissionEnum.DOCUMENTS_LIST,
        actions: [
          {
            key: PermissionEnum.DOCUMENTS_CREATE_ACTION,
          },
          {
            key: PermissionEnum.DOCUMENTS_UPDATE_ACTION,
          },
          {
            key: PermissionEnum.DOCUMENTS_COMMENTS_ACTION,
          },
        ],
      },
      {
        key: PermissionEnum.AGREEMENTS_LIST,
        actions: [
          {
            key: PermissionEnum.AGREEMENTS_CREATE_ACTION,
          },
          {
            key: PermissionEnum.AGREEMENTS_ARCHIVE_ACTION,
          },
        ],
      },
      {
        key: PermissionEnum.APPLICATIONS_SCHEMES_LIST,
        actions: [
          {
            key: PermissionEnum.APPLICATIONS_SCHEMES_CREATE_ACTION,
          },
          {
            key: PermissionEnum.APPLICATIONS_SCHEMES_EDIT_ACTION,
          },
        ],
      },
      {
        key: PermissionEnum.AUDIT_LOG_LIST,
      },
      {
        key: PermissionEnum.NOTIFICATIONS_TYPES_TEMPLATE_LIST,
        actions: [
          { key: PermissionEnum.NOTIFICATIONS_TYPES_TEMPLATE_CREATE_ACTION },
          { key: PermissionEnum.NOTIFICATIONS_TYPES_TEMPLATE_EDIT_ACTION },
        ],
      },
      {
        key: PermissionEnum.CASP_LIST,
        actions: [
          { key: PermissionEnum.CASP_CREATE_ACTION },
          { key: PermissionEnum.CASP_UPDATE_ACTION },
          { key: PermissionEnum.CASP_EDIT_STATUS_ACTION },
        ],
      },
      {
        key: PermissionEnum.CASP_ALIAS_LIST,
        actions: [
          { key: PermissionEnum.CASP_ALIAS_CREATE_ACTION },
          { key: PermissionEnum.CASP_ALIAS_UPDATE_ACTION },
          { key: PermissionEnum.CASP_ALIAS_DELETE_ACTION },
        ],
      },
      {
        key: PermissionEnum.LOCKS_LIST,
        actions: [
          { key: PermissionEnum.LOCKS_CREATE_ACTION },
          { key: PermissionEnum.LOCKS_UPDATE_ACTION },
        ],
      },
      {
        key: PermissionEnum.ANONYMIZE_LOGS_LIST,
      },
      {
        key: PermissionEnum.TRANSACTIONS_RULES_LIST,
        actions: [
          { key: PermissionEnum.TRANSACTIONS_RULES_CREATE_ACTION },
          { key: PermissionEnum.TRANSACTIONS_RULES_EDIT_ACTION },
        ],
      },
      {
        key: PermissionEnum.PURPOSE_CODE_SETTINGS_LIST,
        actions: [
          { key: PermissionEnum.PURPOSE_CODE_SETTINGS_CREATE_ACTION },
          { key: PermissionEnum.PURPOSE_CODE_SETTINGS_EDIT_ACTION },
          { key: PermissionEnum.PURPOSE_CODE_SETTINGS_DELETE_ACTION },
        ],
      },
      {
        key: PermissionEnum.DICTIONARIES_LIST,
      },
      {
        key: PermissionEnum.DICTIONARIES_ITEMS_LIST,
        actions: [
          {
            key: PermissionEnum.DICTIONARIES_ITEMS_CREATE_ACTION,
          },
          {
            key: PermissionEnum.DICTIONARIES_ITEMS_UPDATE_ACTION,
          },
          {
            key: PermissionEnum.DICTIONARIES_ITEMS_DELETE_ACTION,
          },
        ],
      },
      {
        key: PermissionEnum.OTHER_LIST,
        actions: [
          { key: PermissionEnum.SETTINGS_COUNTRIES_EDIT_RISK_SCORE_ACTION },
          { key: PermissionEnum.SETTINGS_COUNTRIES_EDIT_ACTIVE_ACTION },
          { key: PermissionEnum.OVERDRAFT_ENABLE_ALL_ACTION },
          { key: PermissionEnum.OVERDRAFT_ENABLE_CUSTOMERS_ACTION },
          { key: PermissionEnum.IBAN_BIC_SEARCH_ACTION },
          { key: PermissionEnum.IBAN_BIC_VALIDATE_ACTION },
          { key: PermissionEnum.IBAN_VALIDATE_ACTION },
        ],
      },
    ],
  },
  {
    key: PermissionEnum.SECTION_NOTIFICATIONS,
    pages: [
      {
        key: PermissionEnum.NOTIFICATIONS_LIST,
        actions: [{ key: PermissionEnum.NOTIFICATIONS_EDIT_ACTION }],
      },
      {
        key: PermissionEnum.NOTIFICATIONS_COMMENTS_LIST,
        actions: [
          { key: PermissionEnum.NOTIFICATIONS_COMMENTS_CREATE_ACTION },
          { key: PermissionEnum.NOTIFICATIONS_COMMENTS_EDIT_ACTION },
        ],
      },
      {
        key: PermissionEnum.NOTIFICATIONS_ISSUES_LIST,
        actions: [{ key: PermissionEnum.NOTIFICATIONS_ISSUES_EDIT_ACTION }],
      },
      {
        key: PermissionEnum.NOTIFICATIONS_ISSUES_COMMENTS_LIST,
        actions: [
          { key: PermissionEnum.NOTIFICATIONS_ISSUES_COMMENTS_CREATE_ACTION },
          { key: PermissionEnum.NOTIFICATIONS_ISSUES_COMMENTS_EDIT_ACTION },
        ],
      },
    ],
  },
];

export default permissionsTree;
